import { MonthlyCalendar } from '@app/components/Calendars/MonthlyCalendar/MonthlyCalendar.main';

export { MonthlyCalendar };
